










































































































import Vue, { PropOptions } from 'vue'; // eslint-disable-line

type BaseInputProps = {
  name: string;
  required?: boolean;
  placeholder?: string;
  error: string;
  disabled?: boolean;
}
type TextInputProps = BaseInputProps & { type: 'text' }
type DateInputProps = BaseInputProps & { type: 'date' }
type NumberInputProps = BaseInputProps & { type: 'number' }
type CheckboxInputProps = BaseInputProps & { type: 'checkbox' }
type RadioInputProps = BaseInputProps & { type: 'radio' }
type TextareaInputProps = BaseInputProps & { type: 'textarea'; rows: number; resizable?: boolean }
type PasswordInputProps = BaseInputProps & { type: 'password' }

export type VariableInputProps =
  | TextInputProps
  | DateInputProps
  | NumberInputProps
  | CheckboxInputProps
  | RadioInputProps
  | TextareaInputProps
  | PasswordInputProps;

export default Vue.extend({
  name: 'VariableInput',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: String,
    type: String,
    name: String,
    options: Array,
    model: Array,
    rows: Number,
    resizable: {
      type: Boolean,
      required: false,
      default: true
    },
    errorMessage: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    maxLength: Number,
  },
  data() {
    return {
      passwordFlg: false,
    }
  },
  /* eslint-disable */
  computed: {
    inputType() {
      return (this as any).passwordFlg ? 'text' : 'password';
    },
    toggleEye() {
      return (this as any).passwordFlg === true ? 'password-eye' : 'password-eye-slash';
    },
  },
  watch: {
    // value() {
    //   (this as any).resize();
    // },
  },
  methods: {
    togglePassword() {
      (this as any).passwordFlg = !(this as any).passwordFlg;
    },
  },
});
